import { useEffect, useState } from 'react';
import { Seo, CONTACT_EMAIL } from '../components/Seo';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Markdown } from '../components/Markdown';

const API = process.env.REACT_APP_BACKEND_URL;

const NEEDED = [
  'Name der verantwortlichen Person bzw. des Unternehmens',
  'Vollständige Postadresse',
  'Gegebenenfalls Handelsregister- und UID-Angaben',
  'Gegebenenfalls Angaben zu Aufsichtsbehörde oder Berufsrecht',
];

export default function Impressum() {
  const [cms, setCms] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/pages/impressum`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setCms)
      .catch(() => {});
  }, []);

  if (cms?.content) {
    return (
      <>
        <Seo
          title={cms.seo_title || 'Impressum | Felix Genuss'}
          description={cms.meta_description || 'Impressum von Felix Genuss.'}
          path="/impressum"
        />
        <Breadcrumbs items={[{ label: 'Startseite', href: '/' }, { label: 'Impressum' }]} />
        <div className="container-site max-w-3xl pt-10" data-testid="impressum-cms">
          <h1 className="font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">{cms.title}</h1>
          <div className="mt-8">
            <Markdown>{cms.content}</Markdown>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Seo title="Impressum | Felix Genuss" description="Impressum von Felix Genuss – Angaben gemäss den gesetzlichen Anforderungen." path="/impressum" />
      <Breadcrumbs items={[{ label: 'Startseite', href: '/' }, { label: 'Impressum' }]} />
      <div className="container-site max-w-3xl pt-10">
        <h1 className="font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">Impressum</h1>
        <div className="mt-8 border-l-2 border-brand-gold bg-brand-beige p-6" data-testid="impressum-hinweis">
          <h2 className="font-serif text-xl font-bold">Für Produktionsfreigabe erforderlich</h2>
          <p className="mt-3 text-sm leading-relaxed text-brand-brown">
            Das rechtskonforme Impressum wird vor der Veröffentlichung ergänzt. Dafür werden folgende Angaben benötigt:
          </p>
          <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-relaxed text-brand-brown/90 marker:text-brand-gold">
            {NEEDED.map((n) => (
              <li key={n}>{n}</li>
            ))}
          </ul>
        </div>
        <p className="mt-8 leading-relaxed text-brand-brown/85">
          Verantwortlich für den Inhalt dieser Website ist die Betreiberin bzw. der Betreiber von Felix Genuss. Die konkreten Angaben folgen mit den oben genannten Informationen.
        </p>
        <section className="mt-8" aria-labelledby="impressum-kontakt">
          <h2 id="impressum-kontakt" className="font-serif text-2xl font-bold">Kontakt</h2>
          <p className="mt-3 leading-relaxed text-brand-brown/85">
            Felix Genuss
            <br />
            E-Mail:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`} className="link-inline" data-testid="impressum-email-link">
              {CONTACT_EMAIL}
            </a>
          </p>
        </section>
      </div>
    </>
  );
}
